module.exports = __webpack_public_path__ + "static/img/logo-1.d647d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/logo-1.png
// module id = 76DN
// module chunks = 0